import './parts/use-animation';
/**
 * トグルメニュー
 */
function isPassiveSupported() {
  var passiveSupported = false;

  try {
    // eslint-disable-next-line getter-return
    window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { passiveSupported = true; } }));
  } catch(err) {
    // console.log(err)
  }

  return passiveSupported;
}

const clickToggleMenu = (elem) => {
	const toggleButton = document.getElementById(elem);

	if (!toggleButton) return;

	toggleButton.addEventListener('click',function(){
		const body = document.body;
		body.classList.toggle('display-menu');
	});
}
clickToggleMenu( 'js-toggle-menu' );
clickToggleMenu( 'js-close-nav' );
clickToggleMenu( 'js-toggle-menu-bg' );

function toggleSearchArea(elem) {
  var toggleSearchBtn = document.getElementById(elem);
  if(!toggleSearchBtn) return;
  toggleSearchBtn.addEventListener('click', function() {
    document.body.classList.toggle('display-search');
  });
}
toggleSearchArea('js-toggle-search');
toggleSearchArea('js-toggle-search-bg');
toggleSearchArea('js-close-search');

function scrollableTable() {

  var tableBoxes = document.getElementsByClassName('scrollable-table');
  if(!tableBoxes) return;
  for(var i=0; i<tableBoxes.length; i++) {
    var tableBox = tableBoxes[i];
    var table = tableBox.firstElementChild;
    if(tableBox.clientWidth < table.clientWidth) {
      var p = document.createElement('div'); //要素の作成
      p.classList.add('scrollable');
      p.innerHTML = '<p class="scrollable__inner"><svg xmlns="http://www.w3.org/2000/svg" width="44.759" height="60.151" viewBox="0 0 44.759 60.151"><g transform="translate(-158.918 0)"><path d="M179.52,50.9h16.294a3.24,3.24,0,0,0,1.951-.654l.789-.6a12.183,12.183,0,0,0,4.425-6.579l.205-.769a14.579,14.579,0,0,0,.493-3.757V21.624a2.5,2.5,0,0,0-.5-1.5,4.245,4.245,0,0,0-5.879-.9l-.423-.506a5.093,5.093,0,0,0-7.086-.708l-.359-.5a4.578,4.578,0,0,0-7.2-.282V4.565a3.829,3.829,0,0,0-.424-1.753,5.181,5.181,0,0,0-9.1-.213l-.087.151a3.834,3.834,0,0,0-.51,1.91V29.179l-3.735-2.645a7.971,7.971,0,0,0-4.607-1.466h-1.213a3.639,3.639,0,0,0-3.639,3.639,5.153,5.153,0,0,0,2.212,4.232l1.454,1.011a23.223,23.223,0,0,1,7.366,8.394l1.425,2.756a10.962,10.962,0,0,0,5.273,4.976l.918.409a4.8,4.8,0,0,0,1.954.416" fill="currentColor"/><path d="M195.908,60.151H178.429a1.039,1.039,0,0,1-1.039-1.039V55.051a1.039,1.039,0,0,1,1.039-1.039h17.479a1.039,1.039,0,0,1,1.039,1.039v4.061a1.039,1.039,0,0,1-1.039,1.039" fill="currentColor"/></g></svg>→</p>';
      tableBox.parentNode.insertBefore(p, tableBox.nextSibling);
      tableBox.addEventListener('scroll',removeScrollable, isPassiveSupported() ? { passive: true } : false);
      tableBox.addEventListener('touchend',removeScrollable);
    }
  }
  function removeScrollable(e) {
    var nextText = e.target.nextSibling;
    if(nextText.nodeName === '#text') return;
    if(nextText.classList.contains('scrollable')) {
      nextText.style.opacity = 0;
    }
  }
}
scrollableTable();

(function(){
  // YouTube画像化
  var youtube = document.getElementsByClassName('youtube');
  for(var i=0;i<youtube.length;i++){
    youtube[i].addEventListener('click',loadYouTube);
    youtube[i].addEventListener('touchstart', loadYouTube, isPassiveSupported() ? { passive: true } : false);
  }

  function loadYouTube() {
    const video = '<div class="youtube-iframe"><iframe src="'+ this.getAttribute('data-video') +'" frameborder="0" width="480" height="270"></iframe></div>';
    this.outerHTML = video;
  }
}());

window.addEventListener("pageshow", function(event){
  if (event.persisted) {
    document.body.style.opacity = '0';
    window.location.reload();
  }
});

const showFixedHeader = () => {

	const header = document.querySelector('.header--fixed-delay, .header--transparent-fixed-delay');

	if (!header) return;
	
	const trigger = document.getElementById('js-trigger-header-fix');

	if (!trigger) return;

	const observer = new IntersectionObserver((entries) => {
		for (const e of entries) {
			if (e.isIntersecting) {
				header.classList.remove('is-show');
			} else {
				header.classList.add('is-show');
			}
		}
		}, {});
		observer.observe(trigger);
	}
showFixedHeader();

const stickySidebarTop = () => {
	const header = document.querySelector('.header--fixed .header-wrapper, .header--fixed-delay .header-wrapper, .header--transparent-fixed-delay .header-wrapper, .header--transparent-fixed .header-wrapper');

	if (!header) return;

	const stickyWidget = document.querySelector('.sidebar-module--sticky');

	if (!stickyWidget) return;

	const headerHeight = header.clientHeight;

	const body = document.body;

	let margin = 10;

	if (body.classList.contains('admin-bar')) {
		margin = 42;
	}

	const top = (headerHeight + margin) + 'px';

	stickyWidget.style.top = top;
}

stickySidebarTop();

const checkMatchMedia  = () => {
	const mediaQueryList = matchMedia('(min-width:992px)');

	mediaQueryList.addEventListener('change', (e) => {
		if (e.matches) {
			stickySidebarTop();
		}
	});
}
checkMatchMedia();
